import React from 'react'
import { CreditCardData } from '~/types'
import styled from 'styled-components'
import Modal from '~/components/molecules/Modal'
import CreditCardForm from '~/components/organisms/CreditCardForm'

interface Props {
  show: boolean
  creditCard: CreditCardData
  onChange(): void
  onClose(): void
}

export default function CreditCardModal({ show, creditCard, onChange, onClose }: Props) {
  if (creditCard === undefined) {
    return null
  }

  if (creditCard) {
    return (
      <Modal show={show} type='slide' onClose={onClose}>
        <Container>
          <Title>クレジットカードを変更</Title>
          <CreditCardForm type='edit' onChange={onChange} onClose={onClose} />
        </Container>
      </Modal>
    )
  }

  return (
    <Modal show={show} type='slide' onClose={onClose}>
      <Container>
        <Title>クレジットカードを設定</Title>
        <CreditCardForm type='add' onChange={onChange} onClose={onClose} />
      </Container>
    </Modal>
  )
}

const Container = styled.div`
  margin: 0 auto;
  text-align: center;
`

const Title = styled.p`
  ${({ theme }) => theme.fonts.Bold20};
  color: ${({ theme }) => theme.colors.OnSurface2};
  margin: 0 0 24px;
`
